import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import {
  CaptureWeightResponse,
  MeasuredValueDto,
  WeightThresholdCheckResult,
  WeightThresholdDto
} from "~/types/api";

type AutostorePickingState = {
  pickCompartment: number;
  currentPickQuantity: number;
  weightCaptureResponse: CaptureWeightResponse | null;
};

const initialState: AutostorePickingState = {
  pickCompartment: 0,
  currentPickQuantity: 0,
  weightCaptureResponse: null
};

export const autostorePickingSlice = createSlice({
  name: "autostorePicking",
  initialState,
  reducers: {
    setPickCompartment(state, action: PayloadAction<number>) {
      state.pickCompartment = action.payload;
    },
    setCurrentPickQuantity(state, action: PayloadAction<number>) {
      state.currentPickQuantity = action.payload;
    },
    setWeightCaptureResponse(
      state,
      action: PayloadAction<CaptureWeightResponse>
    ) {
      state.weightCaptureResponse = action.payload;
    },
    setWeightsCapturedOnPickSoFar(
      state,
      action: PayloadAction<MeasuredValueDto[]>
    ) {
      if (state.weightCaptureResponse) {
        state.weightCaptureResponse.allWeightsCapturedOnPickSoFar =
          action.payload;
      }
    },
    resetWeightCaptureResponse(state) {
      state.weightCaptureResponse = null;
    }
  },
  selectors: {
    selectPickCompartment: (state: AutostorePickingState) =>
      state.pickCompartment,
    selectCurrentPickQuantity: (state: AutostorePickingState) =>
      state.currentPickQuantity,
    selectWeightsCapturedOnPickSoFar: (
      state: AutostorePickingState
    ): MeasuredValueDto[] =>
      state.weightCaptureResponse?.allWeightsCapturedOnPickSoFar ?? [],
    selectWeightThresholdCheckResult: (
      state: AutostorePickingState
    ): WeightThresholdCheckResult =>
      state.weightCaptureResponse?.weightThresholdCheckResult ??
      "WithinThreshold",
    selectSumOfWeightsCapturedOnPickSoFar: (
      state: AutostorePickingState
    ): MeasuredValueDto | undefined =>
      state.weightCaptureResponse?.sumOfWeightsCapturedOnPickSoFar,
    selectWeightThresholdLeftToPick: (
      state: AutostorePickingState
    ): WeightThresholdDto | undefined =>
      state.weightCaptureResponse?.weightThresholdLeftToPick
  }
});

export const {
  setPickCompartment,
  setCurrentPickQuantity,
  setWeightCaptureResponse,
  resetWeightCaptureResponse,
  setWeightsCapturedOnPickSoFar
} = autostorePickingSlice.actions;

export const {
  selectPickCompartment,
  selectCurrentPickQuantity,
  selectWeightsCapturedOnPickSoFar,
  selectWeightThresholdCheckResult,
  selectSumOfWeightsCapturedOnPickSoFar,
  selectWeightThresholdLeftToPick
} = autostorePickingSlice.selectors;
